module.exports = __webpack_public_path__ + "img/menu-icon-cases.ecc1d3d3.png";